module.exports = __webpack_public_path__ + "img/NarminOsman-Draxt.28903dbb.jpg";